import { render } from "./New-page-key-folder.vue?vue&type=template&id=58d3856b&scoped=true"
import script from "./New-page-key-folder.vue?vue&type=script&lang=js"
export * from "./New-page-key-folder.vue?vue&type=script&lang=js"

import "./New-page-key-folder.vue?vue&type=style&index=0&id=58d3856b&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58d3856b"]])

export default __exports__